import { CategoryInformationFormFragment } from 'generated/resources/graphql'

const defaultCategory = (data?: CategoryInformationFormFragment | null) => {
  if (data?.expense?.category?.id) {
    return data.expense.category.id
  }

  if (data?.mileage) {
    return 'mileage'
  }

  if (data?.perDiem) {
    return 'perdiem'
  }

  return null
}

const defaultSubcategory = (data?: CategoryInformationFormFragment | null) => {
  if (data?.expense?.subcategory) {
    return data?.expense?.subcategory
  }

  if (data?.mileage?.subcategory) {
    return data?.mileage?.subcategory
  }

  if (data?.perDiem?.subcategory) {
    return data?.perDiem?.subcategory
  }

  return null
}
export const getCategoryDefaultValues = (data?: CategoryInformationFormFragment | null) => {
  const category = defaultCategory(data)
  const subcategory = defaultSubcategory(data)

  return {
    category,
    subcategory,
  }
}
